import ProductPage from "../controllers/product";

const productPage = new ProductPage(
	window.ProductPageAddToCartUrl,
	window.ProductPageGetLinkCartUrl,
	window.ProductPageCartLockedUrl,
	window.ChangeProductQuantityUrl,
	window.floatingCartUrl
);